export default __webpack_public_path__ + "static/employee-6b3c81687784f2e3f8cc5e4b46898957.jpg";